import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { getUrlParam } from '@/assets/utils/util'
import COMMON_ENV from '@/config/env'

// 屏蔽路由重复报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

const mainRoutes = [
  { path: '', redirect: 'index' },
  {
    path: 'index',
    name: '首页',
    meta: {
      title: '首页_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/index/index.vue')
  },
  {
    path: 'topiclist',
    name: '专题',
    meta: {
      title: '专题_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/topiclist/index.vue')
  },
  {
    path: 'topiclist/details',
    name: '专题详情',
    meta: {
      title: '专题_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/topiclist/detailList.vue')
  },
  {
    path: 'information',
    name: '资讯',
    meta: {
      title: '资讯_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/information/index.vue')
  },
  {
    path: 'information/detail',
    name: '资讯详情页',
    meta: {
      title: '资讯_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/information/detail.vue')
  },
  {
    path: 'search',
    name: '搜索',
    meta: {
      title: '搜索_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/search/index.vue')
  },
  {
    path: 'regulation',
    name: '法规',
    meta: {
      title: '法规_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/regulation/index.vue')
  },
  {
    path: 'regulation/detail',
    name: '法规详情页',
    meta: {
      title: '法规_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/regulation/detail.vue')
  },
  {
    path: 'interpretation',
    name: '解读',
    meta: {
      title: '解读_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/interpretation/index.vue')
  },
  {
    path: 'interpretation/detail',
    name: '解读详情页',
    meta: {
      title: '解读_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/interpretation/detail.vue')
  },
  {
    path: 'practice',
    name: '实务',
    meta: {
      title: '实务_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/practice/index.vue')
  },
  {
    path: 'practice/detail',
    name: '实务详情页',
    meta: {
      title: '实务_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/practice/detail.vue')
  },
  {
    path: 'case',
    name: '案例',
    meta: {
      title: '案例_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/case/index.vue')
  },
  {
    path: 'case/detail',
    name: '案例详情页',
    meta: {
      title: '案例_优税法规',
      isNotNeedLogin: true
    },
    component: () => import('@/views/case/detail.vue')
  },
  {
    path: 'member',
    meta: {
      title: '会员中心'
    },
    component: () => import('@/views/member/index.vue'),
    children: [
      { path: '/', redirect: '/member/favorite' },
      {
        path: '/member/setting',
        name: '个人设置',
        meta: {
          title: '个人设置_优税法规'
        },
        component: () => import('@/views/member/setting.vue')
      },
      {
        path: '/member/favorite',
        name: '我的收藏',
        meta: {
          title: '我的收藏_优税法规'
        },
        component: () => import('@/views/member/favorite.vue')
      }
    ]
  },
  {
    path: 'deleted',
    name: '数据已删除',
    meta: {
      title: '数据已删除',
      isNotNeedLogin: true
    },
    component: () => import('@/views/components/deleted.vue')
  }
]

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      meta: {
        title: '法规端',
        isNotNeedLogin: true
      },
      component: () => import('@/views/layout/index.vue'),
      children: mainRoutes
    },
    {
      path: '/404',
      meta: {
        title: '404',
        isNotNeedLogin: true
      },
      component: () => import('@/views/404.vue')
    }
  ]
})

function replaceFn() {
  // 登录回跳地址转换成hash路由
  let href = window.location.href.substring(0, window.location.href.length - 2)
  let host = href.split('?')[0]
  let queryList = href.split('?')[1].split('&')
  let query = ''
  let path = ''
  if (queryList.length > 0) {
    let i = -1
    queryList.forEach((item, index) => {
      if (item.indexOf(COMMON_ENV.COMMON_REPLACE_URL) === 0) {
        //
        path = decodeURIComponent(item.split('=')[1])
        i = index
      }
    })
    if (i !== -1) {
      queryList.splice(i, 1)
    }
  }
  query = queryList.join('&')
  console.log(`${host}#/${path}?${query}`)
  if (query) {
    window.location.href = `${host}#/${path}?${query}`
  } else {
    window.location.href = `${host}#/${path}`
  }
}

router.beforeEach(async (to, from, next) => {
  // 如果在#/ 之前存在? 号  替换
  // if (window.location.href.indexOf('#') !== -1) {
  //   let arr = window.location.href.split('#');
  //   if (arr[0].indexOf('?') !== -1) {
  //     if (arr[0].indexOf('COMMONREPLACEURL=') === -1) {
  //       // 存在问号  代表参数拼错了 拼到#号前了
  //       let host = arr[0].split('?')[0];

  //       let query = arr[1].indexOf('?') !== -1
  //         ? `#${arr[1]}&${arr[0].split('?')[1]}`
  //         : `#${arr[1]}?${arr[0].split('?')[1]}`;
  //       let url = host + query;
  //       window.location.replace(url);
  //       return;
  //     }
  //   }
  // }

  if (to.matched.length === 0) {
    next('/404')
  }
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('Trident') !== -1 || userAgent.indexOf('MSIE') !== -1) {
    store.commit('setbrowserIe', true)
  } else {
    store.commit('setbrowserIe', false)
  }
  if (to.query) {
    if (to.query.token != null) {
      store.state.refreshForToken = true
      // 单点登录
      store.commit('setToken', to.query.token ? to.query.token : null) // 设置token
      store.commit('setuserInfo', null) // 初始化
      store.commit('setuserId', null) // 初始化
      // let query = to.query
      // delete query.token
      let query = {}
      if (to.query.id) {
        query.id = to.query.id
      }
      next({
        path: to.path,
        query
      })
      return
    }
  }
  // 获取网站信息, 判断是否有网站信息，再判断sourceId是否与原来一样
  if (
    !store.state.siteInfo
    || COMMON_ENV.SOURCE_URL.match(/web-(\d+)\/?/)[1] !== store.state.siteInfo.sourceId
  ) {
    let url = COMMON_ENV.SOURCE_URL
    let res = await Vue.prototype.$api.getDistributorId({
      domain: url
    })
    if (res.data.code === '0000') {
      store.commit('setsiteInfo', res.data.data)
      store.commit('setdistributorId', res.data.data.distributorId)
      let resOpenType = await Vue.prototype.$api.getOpenType({
        simpleCode: res.data.data.sourceId
      })
      if (resOpenType.data.code === '0000') {
        if (resOpenType.data.data !== null) {
          if (resOpenType.data.data === '_self') {
            store.commit('setdistributorOpenType', '_self')
          }
        }
      }
    } else {
      Vue.prototype.$$message({
        message: res.data.message,
        type: 'error'
      })
    }
  }
  if (getUrlParam(COMMON_ENV.COMMON_REPLACE_URL)) {
    // C将COMMON_REPLACE_URL  替换回hash路由
    replaceFn()
    return
  }
  if (to.meta && !to.meta.isHideProcess) {
    NProgress.start()
  }
  if (!store.getters.token) {
    // 没有token
    if (getUrlParam('code')) {
      // 有code说明是登录回跳的，还没有获取token
      let res = await Vue.prototype.$api.getToken({ code: getUrlParam('code') })
      if (res.data.code === 0) {
        let resUserInfo = await Vue.prototype.$api.getUserInfoByToken({ token: res.data.data.access_token })
        // 获取token 成功
        store.commit('setToken', res.data.data.access_token) // 设置token
        if (resUserInfo.data.code === '0000') {
          store.commit('setuserInfo', resUserInfo.data.data) // 设置用户信息
        } else {
          store.commit('setuserInfo', null) // 重置用户信息
        }
        store.commit('setuserId', res.data.data.userId) // 设置用户ID
        let query = to.query
        delete query.code
        next({
          path: to.path,
          query
        }) // 过滤掉?code=
      } else {
        Vue.prototype.$$message({
          message: res.data.msg,
          type: 'warning'
        })
        next()
      }
    } else if (to.meta && to.meta.isNotNeedLogin) {
      // 如果没有code而且也不要登录就可以直接跳转
      next()
    } else {
      // 没有code又需要登录就去登录
      Vue.prototype.$api.login('login', to.fullPath)
    }
  } else {
    // 有token，证明登录过了都可以跳转
    next()
  }
})

router.afterEach(async to => {
  if (/detail/.test(to.path)) {
    window.scrollTo(0, 0)
  }
  document.title = to.meta.title || '加载中...'
  if (!to.meta.isHideProcess) {
    NProgress.done()
  }
})

export default router
